<template>
    <div class="main-visual">
        <swiper class="swiper" :options="swiperOptions">
            <swiper-slide>
                <v-card flat rounded="0">
                    <div class="main-visual__inner">
                        <div class="main-visual__img d-md-none" style="background-image: url(/images/main/visual.jpg)" />
                        <div class="main-visual__img d-none d-md-block" style="background-image: url(/images/main/visual.jpg)" />

                        <v-container>
                            <tit-wrap-tertiary class="pb-0">
                                <span v-html="$t('visual1.tit')" /> <span class="d-inline-block rounded-sm primary px-8px py-4px px-lg-12px py-lg-6px rounded--xl break-keep">{{ $t("사업명") }}</span>
                                <template #txt>
                                    <span v-html="$t('visual1.txt')" />
                                </template>
                            </tit-wrap-tertiary>
                        </v-container>
                    </div>
                </v-card>
            </swiper-slide>

            <div class="swiper-control" slot="pagination" @click.prevent>
                <swiper-pagination-primary />
                <!-- <swiper-btn-wrap-primary>
                    <v-row class="row--xs">
                        <v-col cols="auto">
                            <swiper-button-primary />
                        </v-col>
                        <v-col cols="auto">
                            <swiper-button-primary next />
                        </v-col>
                    </v-row>
                </swiper-btn-wrap-primary> -->
            </div>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import SwiperPaginationPrimary from "@/components/publish/parents/swipers/swiper-pagination-primary.vue";
import SwiperBtnWrapPrimary from "@/components/publish/parents/swipers/swiper-btn-wrap-primary.vue";
import SwiperButtonPrimary from "@/components/publish/parents/swipers/swiper-button-primary.vue";
import BtnArrowPrimary from "@/components/publish/parents/buttons/btn-arrow-primary.vue";

import TitWrapTertiary from "@/components/publish/parents/typography/tit-wrap-tertiary.vue";

export default {
    components: {
        Swiper,
        SwiperSlide,
        SwiperPaginationPrimary,
        SwiperBtnWrapPrimary,
        SwiperButtonPrimary,
        BtnArrowPrimary,
        TitWrapTertiary,
    },
    props: {},
    data() {
        return {
            swiperOptions: {
                allowTouchMove: true,
                centeredSlides: true,
                spaceBetween: 0,
                effect: 'fade',
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    // renderBullet: function (index, className) {
                    //     function numberAppend(n) {
                    //         return n < 10 ? "0" + n.toString() : n.toString();
                    //     }
                    //     return '<span class="' + className + '">' + numberAppend(index + 1) + "</span>";
                    // },
                },
                // navigation: {
                //     nextEl: ".main-visual .swiper-button-next",
                //     prevEl: ".main-visual .swiper-button-prev",
                // },
            },
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
// main-visual
.main-visual {
    width: 100%;
    &__inner {
        position: relative;
        display: flex;
        align-items: center;
        max-width: 1920px;
        width: 100%;
        height: 500px;
        margin: auto;
    }
    &__img {
        position: absolute;
        top: 0;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        max-width: calc(100% + 2px);
        width: calc(100% + 2px);
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-color: rgba(0, 0, 0, 0.25);
    }
    .container {
        margin-top: var(--header-height);
        z-index: 1;
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .main-visual {
        &__inner {
            height: 700px;
        }
    }
}
@media (min-width: 1024px) {
    .main-visual {
        &__inner {
            min-height: 800px;
            height: 100vh;
        }
    }
}
</style>
